export const getSDKConfig = () => {
  const defaultTvConfig = {
    investor_events: {
      isGADefaultAllow: true,
    },
    default_behavior: false,
    priority_events: [
      'session_start',
      'app_launch',
      'watch_cta_click',
      'view_item_list',
      'asset_click',
      'video_stop',
      'video_start',
      'video_play_start',
      'log_in_success',
      'log_in_detail_submit',
      'video_ad_start',
      'video_ad_request',
      'screenview_manual',
      'pageview_manual',
      'subscription_success',
      'subscription_proceed_click',
      'subscription_payment_method_select',
      'sub_tv_activation_click',
      'sub_smarthook_click',
      'sub_restore_success',
      'sub_restore_click',
      'sub_renew_expiry_notification_view',
      'sub_renew_expiry_noti_click',
      'sub_proceed_to_pay_click',
      'sub_my_account_click',
      'sub_activation_okay',
      'qr_scan_login_success',
      'qr_scan_login_detail_submit',
      'hamburger_menu_subscribe_click',
      'get_premium_click',
      'free_preview_subscribe_click',
      'free_preview_subscribe_click',
      'shorts_video_start',
    ],
    blacklist: {
      event_types: ['others'],
      event_categories: ['debug'],
      event_name: ['test_event'],
    },
    priority: {
      max_retries: 3,
      retry_backoff: 3000,
      discard_on_failure: true,
      offline_cache_enabled: true,
      offline_cache_max_size: 50,
      offline_cache_flush_interval: 604800,
    },
    batch: {
      max_retries: 3,
      retry_backoff: 3000,
      discard_on_failure: false,
      queue_size: 50,
      batch_interval: 300000,
      compression_enabled: true,
      max_events_per_beacon: 25,
      offline_cache_enabled: true,
      offline_cache_max_size: 50,
      offline_cache_flush_interval: 604800,
    },
    general: {
      app_session_timeout: 1800000,
      api_timeout: 15000,
      debug_mode: false,
      compression: {
        enabled: true,
      },
      rate_limit: {
        enabled: true,
        max_beacons_per_minute: 120,
        burst_limit: 50,
      },
      beacon_flush_on_critical: true,
      endpoints: {
        priority: 'https://evt.sonyliv.com/v2/smarttv/priority/records',
        batched: 'https://evt.sonyliv.com/v2/smarttv/batched/records',
      },
    },
  };

  const defaultWebConfig = {
    investor_events: {
      isGADefaultAllow: true,
    },
    default_behavior: false,
    blacklist: {
      event_types: ['others'],
      event_categories: ['debug'],
      event_name: ['test_event'],
    },
    priority: {
      max_retries: 5,
      retry_backoff: 2000,
      discard_on_failure: true,
      offline_cache_enabled: true,
      offline_cache_max_size: 1000,
      offline_cache_flush_interval: 604800,
    },
    batch: {
      max_retries: 3,
      retry_backoff: 5000,
      discard_on_failure: false,
      queue_size: 200,
      batch_interval: 300000,
      compression_enabled: true,
      max_events_per_beacon: 100,
      offline_cache_enabled: true,
      offline_cache_max_size: 1000,
      offline_cache_flush_interval: 604800,
    },
    general: {
      app_session_timeout: 1800000,
      api_timeout: 15000,
      debug_mode: false,
      compression: { enabled: true },
      rate_limit: {
        enabled: true,
        max_beacons_per_minute: 120,
        burst_limit: 50,
      },
      beacon_flush_on_critical: true,
      endpoints: {
        priority: 'https://evt.sonyliv.com/v2/web/priority/records',
        batched: 'https://evt.sonyliv.com/v2/web/batched/records',
      },
    },
    priority_events: [
      'asset_click',
      'video_stop',
      'video_start',
      'video_play_start',
      'log_in_success',
      'log_in_detail_submit',
      'video_ad_start',
      'video_ad_request',
      'screenview_manual',
      'pageview_manual',
      'subscription_success',
      'subscription_proceed_click',
      'subscription_payment_method_select',
      'sub_tv_activation_click',
      'sub_smarthook_click',
      'sub_restore_success',
      'sub_restore_click',
      'sub_renew_expiry_notification_view',
      'sub_renew_expiry_noti_click',
      'sub_proceed_to_pay_click',
      'sub_my_account_click',
      'sub_activation_okay',
      'qr_scan_login_success',
      'qr_scan_login_detail_submit',
      'hamburger_menu_subscribe_click',
      'get_premium_click',
      'free_preview_subscribe_click',
      'free_preview_subscribe_click',
      'shorts_video_start',
      'session_start',
      'app_launch',
      'watch_cta_click',
      'view_item_list',
    ],
  };

  const localPlatform = localStorage.getItem('GV_NETWORK_PLATFORM_TYPE');

  let defaultConfig = defaultTvConfig;
  if (localPlatform === 'WEB') {
    defaultConfig = defaultWebConfig;
  }

  const gvlocalSDK = localStorage.getItem('GV_SDK_CONFIG');
  let localSDK = null;
  try {
    let storedSdk = JSON.parse(gvlocalSDK);
    if (typeof storedSdk === 'object' && Object.keys(storedSdk).length > 0) {
      localSDK = storedSdk;
    }
  } catch (e) {
    console.info('wrong localSDK', e);
  }

  const config =
    window.spnGlobalConfig?.spnGodavariGaAnalyticsConfig ||
    (typeof localSDK === 'object' && !!localSDK && localSDK) ||
    defaultConfig;
  return config;
};

export function setSDKConfig(config) {
  if (window.spnGlobalConfig && config) {
    //dispatch all previous events if currently present in queue with old config
    window.spnGlobalConfig.spnGodavariGaAnalyticsConfig = config;
    localStorage.setItem('GV_SDK_CONFIG', JSON.stringify(config));
  }
}
